import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function UpdateFilters ({
  open,
  category,
  loadingSub,
  handleClose,
  addOptionRow,
  handleSubmit,
  subcategories,
  removeOptionRow,
  expandedCategory,
  updateCategoryData,
  handleOptionChange,
  deleteFilterOption,
  handleAccordionChange,
  handleChangeUpdateCategory,
}) {
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{"Update Filter"}</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Name</label>
                  <input
                    value={updateCategoryData?.name}
                    onChange={handleChangeUpdateCategory}
                    name='name'
                    type='text'
                    required
                    placeholder='Enter Filter name'
                    style={{
                      padding: "10px",
                      border: "2px solid #c4c4c4",
                      borderRadius: "6px",
                      color: "gray",
                      width: "260px",
                    }}
                  />
                </div>
                <div style={{ paddingTop: "10px" }}>
                  <lable>Visible</lable>
                  <RadioGroup
                    style={{ width: "100%", color: "#7b809a" }}
                    row
                    aria-labelledby='demo-row-radio-buttons-group-label'
                    name='isActive'
                    required
                    onChange={handleChangeUpdateCategory}
                    value={updateCategoryData?.isActive}
                  >
                    <FormControlLabel
                      style={{ fontSize: "12px", color: "#7b809a", fontWeight: 400 }}
                      value={true}
                      control={<Radio size='small' />}
                      label='Yes'
                      defaultChecked={false}
                    />
                    <FormControlLabel
                      style={{ fontSize: "12px", color: "#7b809a" }}
                      value={false}
                      control={<Radio size='small' />}
                      defaultChecked={false}
                      label='Not Yet'
                    />
                  </RadioGroup>
                </div>
              </div>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Select Sub Category</label>
                  {category.map(cat => (
                    <Accordion
                      key={cat.categoryId}
                      expanded={expandedCategory === cat.categoryId}
                      onChange={handleAccordionChange(cat.categoryId)}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography style={{ fontSize: "14px", color: "#7b809a" }}>
                          {cat.name}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {loadingSub && expandedCategory === cat.categoryId ? (
                          <CircularProgress size={20} />
                        ) : subcategories?.length > 0 ? (
                          subcategories.map(sub => (
                            <div
                              key={sub.subCategoryId}
                              onClick={() =>
                                handleChangeUpdateCategory({
                                  target: { name: "subCategoryIds", value: sub.subCategoryId },
                                })
                              }
                              style={{
                                padding: "2px 6px",
                                borderRadius: "4px",
                                color: "#7b809a",
                                fontSize: "13px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                                backgroundColor: updateCategoryData?.subCategoryIds?.some(
                                  id => id.subCategoryId === sub.subCategoryId
                                )
                                  ? "#e5e5e5"
                                  : "transparent",
                              }}
                            >
                              {sub.name}
                            </div>
                          ))
                        ) : (
                          <Typography variant='body2' color='text.secondary'>
                            No subcategories available.
                          </Typography>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
                <div style={{ marginTop: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "10px",
                      alignItems: "center",
                    }}
                  >
                    <label>Options</label>
                    <button
                      type='button'
                      onClick={addOptionRow}
                      style={{
                        color: "gray",
                        backgroundColor: "white",
                        boxShadow: "0 0 4px 2px rgba(0,0,0,0.2)",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Add
                    </button>
                  </div>
                  {updateCategoryData?.options?.map((opt, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "10px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type='text'
                        placeholder='Value'
                        required
                        value={opt.value}
                        onChange={e => handleOptionChange(idx, "value", e.target.value)}
                        style={{
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          width: "120px",
                          fontSize: "14px",
                          color: "#7b809a",
                        }}
                      />
                      <input
                        type='number'
                        placeholder='Order'
                        required
                        value={opt.optionOrder}
                        onChange={e => handleOptionChange(idx, "order", e.target.value)}
                        style={{
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          width: "80px",
                          fontSize: "14px",
                          color: "#7b809a",
                        }}
                      />
                      <button
                        type='button'
                        onClick={() => deleteFilterOption(opt, idx)}
                        style={{
                          backgroundColor: "red",
                          color: "#fff",
                          border: "none",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button autoFocus onClick={handleClose}>
            Disagree
            </Button> */}
            <Button type='submit' autoFocus>
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    // marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "120px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};
